import type { Module } from '@pc/core';
import { probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';

const MessagesPage = lazyWithReload(() => import('./pages/MessagesPage'));

export const messagingModule: Module = {
  id: 'messaging',
  name: 'Messages',
  description:
    'Internal messaging: direct messages, group chats, and wholesaler channels with read state, typing, presence, and email notifications.',
  basePath: '/messages',
  routes: [
    { path: '/', element: <MessagesPage /> },
    { path: '/:conversationId', element: <MessagesPage /> },
  ],
  navItems: [{ label: 'Messages', to: '/messages', order: 12 }],
  healthProbe: () => probeSchemaIsExposed('im', 'conversations'),
};
